<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs>
            <b-tab :title="$t('quran_programs.quran_programs')">
              <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
                <div class="row mb-3 mt-3">
                  <div class="col-md-3"></div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="text"
                        autofocus
                        class="form-control"
                        v-model="search"
                        @input="(val) => searchChange(val)"
                        :placeholder="$t(`site.search`)"
                      />
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="float-md-right pt-1">
                      <span class="text-muted text-small mr-1 mb-2">
                        {{ from }}:{{ to }}
                      </span>

                      <b-dropdown
                        id="ddown2"
                        right
                        :text="`${perPage}`"
                        variant="outline-warning"
                        size="xs"
                      >
                        <b-dropdown-item
                          v-for="(size, index) in [5, 10, 20, 50, 100]"
                          :key="index"
                          @click="changePageSize(size)"
                          >{{ size }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 overflow-auto">
                    <b-table :stacked="($mobile==1)" 
                      ref="table"
                      class="vuetable"
                      sort-by="id"
                      sort-desc.sync="false"
                      :current-page="currentPage"
                      :fields="bootstrapTable.fields"
                      :items="dataProvider"
                      style="min-height: 200px"
                    >
                      <template #cell(checkbox)="data">
                        {{ data.index + 1 + perPage * (currentPage - 1) }}
                      </template>
                      <template #cell(students)="data">
                        {{ data.item.students.length }}
                      </template>

                      <template #cell(room_type)="data">
                        <b-badge
                          variant="light-info"
                          v-if="data.item.room_type == 0"
                        >
                          جماعي
                        </b-badge>
                        <b-badge variant="light-dark" v-else> فردي </b-badge>
                      </template>
                      <template #cell(edit)="data">
                        <b-button
                          :to="{
                            name: 'QuranProgramTiming',
                            params: { id: data.item.id },
                          }"
                        >
                          {{ $t("quran_programs.timing") }}
                        </b-button>
                      </template>

                      <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
                    </b-table>

                    <hr />
                    <b-pagination
                      size="sm"
                      align="right"
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        pagination-warning
                      "
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                    >
                      <template v-slot:next-text>
                        <i class="fas fa-angle-left" />
                      </template>
                      <template v-slot:prev-text>
                        <i class="fas fa-angle-right" />
                      </template>
                      <template v-slot:first-text>
                        <i class="fas fa-step-forward" />
                      </template>
                      <template v-slot:last-text>
                        <i class="fas fa-step-backward" />
                      </template>
                    </b-pagination>
                  </div>
                  <!-- end of col -->
                </div>
                <!-- end of row -->
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>
<script>
import controller from "../../../Controllers/QuranProgramsController";
import config from "../../../config/config";

export default {
  name: "MyQuranProgram",
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "title",
            label: this.$i18n.t("quran_programs.program_name"),
            sortable: true,
          },
          {
            key: "language",
            label: this.$i18n.t("quran_programs.language"),
            sortable: true,
          },
          {
            key: "category",
            label: this.$i18n.t("quran_programs.category"),
            sortable: true,
          },
          {
            key: "room_type",
            label: this.$i18n.t("quran_programs.room_type"),
            sortable: true,
          },

          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
    };
  },
  async created() {},

  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().ProgramTeacher(
        this.apiParamsConverter()
      );
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.with = ["quranProgram"];

      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>

